export const OTHER = {
  green: '#5fe400',
  yellow: '#fff000',
  blue: '#1d6aff',
  red: '#cb0000',
  redLight: '#e01313',
}
export const TERTIARY = {
  topaz: '#ffca7b',
  topaz60: '#ffdfb0',
  skyblue: '#84b2f6',
  skyblue60: '#b5d1fa',
  peach: '#f89f83',
  peach60: '#fbc5b5',
  waterspout: '#8ee9d8',
  waterspout60: '#bbf2e8',
  mauve: '#e4b2f6',
  mauve60: '#efd1fa',
  eucalyptus: '#5cdfb0',
  eucalyptus60: '#9decd0',
}
export const PASTEL = {
  cobalt: '#dcdaff',
  blue: '#defaff',
  purple: '#ffe8fd',
  plum: '#f0dde5',
  lime: '#f6ffa2',
  teal: '#c0f4f7',
}
export const SECONDARY = {
  white: '#ffffff',
  putty: '#F2EFE7',
  slate: '#323232',
  charcoal: '#1E1E1E',
  sunglow: '#F9CB2A',
  sunglowLight: '#FAD144',
  pebble: '#65635B',
}
export const PRIMARY = {
  cobaltBlue: '#292287',
  arcticBlue: '#77E1F4',
  richPurple: '#76136E',
  warmPlum: '#9B1C52',
  lime: '#DCEE2A',
  teal: '#007B81',
}

type PlainObject = { [key: string]: string | PlainObject }

export function flattenObject(obj: PlainObject, parentKey: string = '', result: PlainObject = {}): PlainObject {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = parentKey ? `${parentKey}-${key}` : key

      if (typeof obj[key] === 'object' && obj[key] !== null) {
        flattenObject(obj[key] as PlainObject, newKey, result)
      }
      else {
        result[newKey] = obj[key]
      }
    }
  }

  return result
}
